import { withdrawalRequests } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import { settlementBalance } from "./balances.js";

type Db = TestDb;

export async function barberWallet(
  db: Db, barberCounterpartyId: string,
): Promise<{ balanceKopecks: number; owedToBarberKopecks: number }> {
  const balanceKopecks = await settlementBalance(db, barberCounterpartyId);
  const owedToBarberKopecks = balanceKopecks < 0 ? -balanceKopecks : 0;
  return { balanceKopecks, owedToBarberKopecks };
}

export async function createWithdrawalRequest(
  db: Db, input: { barberCounterpartyId: string; amountKopecks: number },
): Promise<{ id: string }> {
  if (!Number.isInteger(input.amountKopecks) || input.amountKopecks <= 0) {
    throw new Error(`WITHDRAWAL_INVALID_AMOUNT: ${input.amountKopecks}`);
  }
  const { owedToBarberKopecks } = await barberWallet(db, input.barberCounterpartyId);
  if (input.amountKopecks > owedToBarberKopecks) {
    throw new Error(`WITHDRAWAL_EXCEEDS_BALANCE: requested=${input.amountKopecks} owed=${owedToBarberKopecks}`);
  }
  const [wr] = await db.insert(withdrawalRequests)
    .values({ barberCounterpartyId: input.barberCounterpartyId, amountKopecks: input.amountKopecks })
    .returning();
  return { id: wr.id };
}
